<template>
    <div class="container">
        <div class="card-item">
            <div class="card-title">
                <p v-for="(item,index) in tabList" :key="index" @click="tabToggle(index)" :class="{active:index === tabListIndex}">{{item}}</p>
            </div>
            <div class="card-content">
                <rewardInformation v-if="tabListIndex == 0" />
                <legalInformation v-if="tabListIndex == 1" />
                <penaltyInformation v-if="tabListIndex == 2" />
                <badBehaviorInformation v-if="tabListIndex == 3" />
                <blackListRecord v-if="tabListIndex == 4" />
                <breakPromise v-if="tabListIndex == 5" />
                <creditHenan v-if="tabListIndex == 6" />
            </div>
            <div v-if="tabListIndex != 6" class="remarks" style="margin-left: 24px;padding-bottom: 12px">备注：系统自动归集信息来自国家信用信息公示平台及相关行业主管部门汇集数据库，自动归集信息只可查看，不可编辑！</div>
            <div v-if="tabListIndex == 6" class="remarks" style="margin-left: 24px;padding-bottom: 12px">备注：系统自动归集信息来自信用河南，自动归集信息只可查看，不可编辑！</div>
        </div>
    </div>
</template>

<script>
    import rewardInformation from './main-rewards-child/reward-information'
    import legalInformation from './main-rewards-child/legal-information'
    import penaltyInformation from './main-rewards-child/penalty-information'
    import badBehaviorInformation from './main-rewards-child/badbehavior-information'
    import blackListRecord from './main-rewards-child/blacklist-records'
    import breakPromise from './main-rewards-child/breakpromise-records'
    import creditHenan from './main-rewards-child/credit-henan'
    export default {
        name: "main-rewards-form",
        data(){
            return {
                tabList: ['奖励信息', '违法违规信息', '行政处罚信息', '不良行为', '黑名单记录', '失信联合惩戒记录', '信用河南公示信息'],
                tabListIndex:0
            }
        },
        components:{
            rewardInformation,
            legalInformation,
            penaltyInformation,
            badBehaviorInformation,
            blackListRecord,
            breakPromise,
            creditHenan
        },
        methods: {
            tabToggle (index) {
                this.tabListIndex = index;
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container{
        .card-item{
            .card-title{
                cursor: pointer;
                display: flex;
                align-items: center;
                p{
                    font-size: 16px;
                    margin: 0 32px;
                }
                .active{
                    color: #1890FF;
                    border-bottom: 2px solid #1890FF;
                    margin-bottom: 2px;
                }
            }
        }
    }
</style>